"use client";

import { useRef } from "react";
import { twMerge } from "tailwind-merge";

import { SEARCH_PARAMS, uuid } from "@/globals";
import { type RSearchFiltersType } from "@/schemes/raabits.scheme";
import { clickSingleton } from "@/singletons/click.singleton";
import { BUTTON_STYLES } from "@/styles/buttons";

import { SearchModuleDisplayView } from "./search-module-display.view";
import { SearchModuleEntriesView } from "./search-module-entries.view";
import { SearchModuleFieldView } from "./search-module-field.view";
import { type SearchModuleFilterRef, SearchModuleFilterView } from "./search-module-filter.view";
import { SearchModuleNavigationView } from "./search-module-navigation.view";

type SearchModuleHeaderProps = {
    baseURL: string;
    currentSearchString: string;
    entryId?: string;
    initialSearchString: string;
    placeholder?: string;
    searchFilters: RSearchFiltersType | undefined;
};

export const SearchModuleHeaderView = ({
    placeholder,
    searchFilters,
    currentSearchString,
    initialSearchString,
    baseURL,
    entryId,
}: SearchModuleHeaderProps) => {
    const filterRef = useRef<SearchModuleFilterRef>(null);

    const handleOpen = () => {
        clickSingleton.toogle();
        clickSingleton.notify();
    };

    return (
        <section id="search-meta-data" className="mb-8">
            <div className="flex flex-col gap-8">
                <div className="flex gap-2 w-full flex-wrap sm:flex-nowrap">
                    <div className="flex gap-2 w-full">
                        <SearchModuleFieldView
                            placeholder={placeholder}
                            currentSearchString={currentSearchString}
                            baseURL={baseURL}
                            entryId={entryId}
                        />
                        <SearchModuleFilterView
                            searchFilters={searchFilters}
                            initialSearchString={initialSearchString}
                            key={uuid()}
                            ref={filterRef}
                            className="sm:hidden"
                            currentSearchString={currentSearchString}
                            entryId={entryId}
                            baseURL={baseURL}
                        />
                    </div>
                    <button
                        onClick={handleOpen}
                        className={twMerge(
                            BUTTON_STYLES.secondary(),
                            "order-first sm:order-last w-full sm:w-auto md:hidden",
                        )}
                    >
                        Kategorien
                    </button>
                </div>
                <SearchModuleNavigationView
                    onClickFach={() => filterRef.current?.handleOpen(SEARCH_PARAMS.faecher)}
                    onClickSchulform={() => filterRef.current?.handleOpen(SEARCH_PARAMS.schularten)}
                    onClickKlassenstufe={() =>
                        filterRef.current?.handleOpen(SEARCH_PARAMS.klassenstufen)
                    }
                    initialSearchString={initialSearchString}
                />
                <div className="items-start flex flex-col sm:flex-row justify-between gap-4">
                    <SearchModuleDisplayView
                        searchFilters={searchFilters}
                        initialSearchString={initialSearchString}
                        currentSearchString={currentSearchString}
                        entryId={entryId}
                        baseURL={baseURL}
                    />
                    <SearchModuleEntriesView
                        currentSearchString={currentSearchString}
                        entryId={entryId}
                        baseURL={baseURL}
                    />
                </div>
            </div>
        </section>
    );
};
